import { render } from "./MilkModal.vue?vue&type=template&id=03e0d895&scoped=true&ts=true"
import script from "./MilkModal.vue?vue&type=script&lang=ts"
export * from "./MilkModal.vue?vue&type=script&lang=ts"

import "./MilkModal.vue?vue&type=style&index=0&id=03e0d895&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e0d895"]])

export default __exports__